import WidgetItemInterface from "@/interfaces/widget-item.interface";
import {WIDGET_ITEMS} from "../../../tests/unit/__mocks__/WidgetItem.mock";

export const WidgetService = {
  fetchWidgets(): Promise<WidgetItemInterface[]> {
    return Promise.resolve(WIDGET_ITEMS);
  }
}
